import { Breadcrumb, Col, Row } from "@pankod/refine-antd";

import { EnvironmentBadge } from "./environment-badge";

export const FeatureFlagsHeaderBreadcrumb: React.FC = () => (
  <Row align="middle" justify="space-between" gutter={[16, 8]}>
    <Col>
      <Breadcrumb />
    </Col>
    <Col>
      <EnvironmentBadge />
    </Col>
  </Row>
);
